import axios from "axios";
import { cookies } from "../hooks/useCookies";

const api = axios.create({  
  baseURL: process.env.REACT_APP_API_URL
  //  baseURL: "https://1e85-179-73-171-247.ngrok-free.app/"
});

async function refreshToken() {
  return new Promise(async (resolve) => {
    await api
      .post("/user/token/refresh/", {
        refresh: cookies.get("Safysign_refresh"),
      })
      .then((response) => {
        const responseData = response.data;
        cookies.set("Safysign_refresh", responseData.refresh);
        cookies.set("Safysign_access", responseData.access);
        defaults.headers.Authorization = `Bearer ${responseData.access}`;
        resolve(true);
      })
      .catch((error) => {
        cookies.remove('Safysign_user')
        cookies.remove('Safysign_access')
        cookies.remove('Safysign_refresh')
        window.location.pathname = '/'
        resolve(error)
      });
  });
}

export function get(path) {
  return new Promise(async (resolve) => {
    await api
      .get(path, defaults)
      .then((response) => {
        resolve(response);
      })
      .catch(async (error) => {
        if (error.response && error.response.status === 401) {
          let res = await refreshToken();
          if (res) {
            await api
              .get(path, defaults)
              .then((response) => {
                resolve(response);
              })
              .catch((error) => {
                resolve(error);
              });
          }
        } else {
          resolve(error);
        }
      });
  });
}
export function destroy(path) {
  return new Promise(async (resolve) => {
    await api
      .delete(path, defaults)
      .then((response) => {
        resolve(response);
      })
      .catch(async (error) => {
        if (error.response.status === 401) {
          let res = await refreshToken();
          if (res) {
            await api
              .delete(path, defaults)
              .then((response) => {
                resolve(response);
              })
              .catch((error) => {
                resolve(error);
              });
          }
        } else {
          resolve(error.data);
        }
      });
  });
}
export function put(path, data) {
  return new Promise(async (resolve) => {
    await api
      .put(path, data, defaults)
      .then((response) => {
        resolve(response);
      })
      .catch(async (error) => {
        if (error.response.status === 401) {
          let res = await refreshToken();
          if (res) {
            await api
              .put(path, data, defaults)
              .then((response) => {
                resolve(response);
              })
              .catch((error) => {
                resolve(error);
              });
          }
        } else {
          resolve(error);
        }
      });
  });
}
export function post(path, data, { content_type }) {
  let _defaults = {
    headers: {
      Authorization: defaults.headers.Authorization,
      "Content-Type": defaults.headers["Content-Type"],
    },
  };
  if (content_type) {
    _defaults.headers["Content-Type"] = content_type;
  }
  return new Promise(async (resolve) => {
    await api
      .post(path, data, _defaults)
      .then((response) => {
        resolve(response);
      })
      .catch(async (error) => {
        if (
          error.response?.status === 401 &&
          error.response?.data?.detail !== "Usuário e/ou senha incorreto(s)"
        ) {
          let res = await refreshToken();
          if (res) {
            await api
              .put(path, data, defaults)
              .then((response) => {
                resolve(response);
              })
              .catch((error) => {
                resolve(error);
              });
          }
        } else {
          resolve(error);
        }
      });
  });
}
export const defaults = {
  headers: {
    Authorization: "",
    "Content-Type": "application/json",
  },
}
